<template>
  <div class="discovery-search-bar">
    <input v-model="searchString" placeholder="Search for...">
    <select v-if="multiSearch" v-model="searchType">
      <option value="catalog">Catalog</option>
      <option value="site">Website</option>
    </select>
  </div>
</template>

<script>
import { debounce } from '@/helpers';

export default {
  name: 'SearchBar',
  props: {},
  data() {
    return {
      multiSearch: true,
      searchType: 'catalog',
      searchString: '',
      searchBy: 'KW',
    };
  },
  watch: {
    // Watch for changes to search string and dispatch search queries
    searchString() { this.debounceSearch(); },
  },
  methods: {
    // Prevents searches from being dispatched too often
    debounceSearch: debounce(function d() { this.emitSearch(); }, 250),
    // Execute a search query
    emitSearch() {
      this.$emit('search', {
        searchString: this.searchString,
        searchBy: this.searchBy,
      });
    },
  },
};
</script>

<style lang="less">
@import '~@/css/global';

.discovery-search-bar {
  display: flex;
  input, select {
    flex: 0 1 auto;
  }
  input {
    padding: @pad-md;
    min-width: 400px;
    width: 100%;
  }
  select {
    min-width: 120px;
  }
}
</style>
